module.exports = __webpack_public_path__ + "static/media/by.837ccf74.svg";